import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES } from '../constants/app.constants';
import { UserRole } from '../constants/roles.enum';

const CLAIMER_ROLES = [UserRole.DOCTOR, UserRole.ADMIN];

/**
 * Restricts the claim page to those who may bind a tag to an entrance. Receptionists are
 * deliberately excluded: claiming decides which centre a sticker speaks for, which is a
 * provisioning decision, not a front-desk one. A doctor additionally needs QualiPass
 * switched on for the account; admins pass regardless.
 */
export const TagClaimerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isUserLoggedIn()) {
    return router.createUrlTree([`/${PUBLIC_ROUTES.login}`]);
  }
  const token = auth.getDecodedToken();
  if (!CLAIMER_ROLES.includes(token.role as UserRole)) {
    return router.createUrlTree([auth.homeRoute()]);
  }
  if (token.role === UserRole.DOCTOR && token.qualipassEnabled !== true) {
    return router.createUrlTree([auth.homeRoute()]);
  }
  return true;
};
